<script>
	const utilities = require('utilities');

	const { authenticateWithGoogleClassroom, isKnownGoogleClass, closeGCAIframe } = require('utilities/googleClassroomUtilities');

	const { deleteAssignment, beginAssignmentAction, endAssignmentAction } = require('utilities/assignmentUtilities');

	module.exports = {
		components: {
			modal: require('./modal.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			message: require('components/message.vue').default
		},
		modelData: ['localGCAccessToken', 'gcClassList', 'gcAddon'],
		data() {
			return {
				assignment: {},
				roster: null,
				loading: false
			};
		},
		methods: {
			authenticateWithGoogle() {
				authenticateWithGoogleClassroom();
			},
			closeModals() {
				utilities.closeModals();
			},
			onConfirmDelete() {
				let assignment = this.assignment;

				this.loading = true;
				beginAssignmentAction();
				return deleteAssignment(assignment)
					.then(() => {
						this.closeModals();
					})
					.finally(() => {
						if (this.gcAddon) {
							closeGCAIframe();
						}
						endAssignmentAction();
						this.loading = false;
					});
			}
		},
		computed: {
			gcTokenMismatch() {
				const gcid = this.roster && this.roster.gcid;

				return gcid && this.gcClassList && !isKnownGoogleClass(gcid);
			},
			needsGoogleAuth() {
				const { gcid, gca } = this.assignment;

				return (gcid || gca) && (!this.localGCAccessToken || this.gcTokenMismatch);
			}
		},
		mounted() {
			this.$subscribe('modal-opened', (modalId, opts) => {
				if (modalId !== 'modal-confirm-delete') {
					return true; // let some other handler take this
				}
				if (opts) {
					this.assignment = opts.assignment;
					this.roster = opts.roster;
				}
				return false;
			});

			this.$subscribe('modal-closed', (modalId, opts) => {
				if (modalId !== 'modal-confirm-delete') {
					return true; // let some other handler take this
				}
				this.assignment = {};
				this.roster = null;
				return false;
			});
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="modal-confirm-delete"
		:loading="loading"
		:ok="false"
		:closeable="!loading"
		:no-auto-close="loading">
		<div slot="header-container">
			<h2>Delete Confirmation</h2>
		</div>
		<div
			class="text-centered"
			slot="content">
			<h3>Are you sure you want to delete the assignment &ldquo;{{ assignment.productMetaData && assignment.productMetaData.title }}&rdquo;?</h3>
			<p>Once deleted, you and your students will no longer be able to access the assignment or see student results.</p>
			<message
				v-if="assignment.gca && !(needsGoogleAuth && gcTokenMismatch)"
				type="info"
				class="text-left gca-message">
				This assignment was published using Google Classroom Add-ons.
				<span v-if="gcAddon">The Add-on Attachment will be deleted, but you will still need to delete the assignment in Google Classroom.</span>
				<span v-else>You will still need to delete the assignment in Google Classroom.</span>
			</message>
			<div
				class="margin-top-bottom-medium"
				v-if="needsGoogleAuth">
				<message
					v-if="gcTokenMismatch"
					class="margin-top-xs"
					type="error">
					Please authenticate the Google account used to manage this Classroom
				</message>
				<a
					class="button"
					@click="authenticateWithGoogle">
					Authenticate With Google
				</a>
			</div>
			<div class="margin-top-bottom-medium">
				<button
					class="button -outline"
					:disabled="needsGoogleAuth"
					@click="closeModals">
					Do Not Delete
				</button>
				<button
					class="button -danger enter-action"
					:disabled="needsGoogleAuth"
					@click="onConfirmDelete(assignment)">
					Delete
				</button>
			</div>
		</div>
	</modal>
</template>
